import React from "react";
import { useTheme } from "./ThemeContext";

const recLabels = {
    accept: "Accept",
    minorRevision: "Minor Revision",
    majorRevision: "Major Revision",
    reject: "Reject",
};

const recColors = {
    accept: { background: "#d1fae5", color: "#065f46" },
    minorRevision: { background: "#dbeafe", color: "#1e40af" },
    majorRevision: { background: "#fef3c7", color: "#92400e" },
    reject: { background: "#fee2e2", color: "#991b1b" },
};

const recColorsDark = {
    accept: { background: "#173a2e", color: "#6ee7b7" },
    minorRevision: { background: "#1a2a4a", color: "#93c5fd" },
    majorRevision: { background: "#3a2e14", color: "#fcd34d" },
    reject: { background: "#3f1d1d", color: "#fca5a5" },
};

export default function ReviewFeedbackView({ feedback }) {
    const { theme } = useTheme();
    if (!feedback) return null;

    const scores = [
        { label: "Novelty", value: feedback.noveltyScore },
        { label: "Methodology", value: feedback.methodologyScore },
        { label: "Impact", value: feedback.impactScore },
        { label: "Overall", value: feedback.overallScore },
    ].filter(s => s.value != null);

    return (
        <div>
            {/* Scores */}
            {scores.length > 0 && (
                <div className="rf-scores-grid" style={{ marginBottom: 16 }}>
                    {scores.map(s => (
                        <div key={s.label} className="submission-score-card">
                            <p className="submission-score-label">{s.label}</p>
                            <p className="submission-score-value">{s.value}</p>
                        </div>
                    ))}
                </div>
            )}

            {/* Recommendation */}
            {feedback.recommendation && (
                <div style={{ marginBottom: 16 }}>
                    <span style={{
                        display: "inline-block",
                        padding: "5px 12px",
                        borderRadius: 8,
                        fontSize: 13,
                        fontWeight: 600,
                        ...((theme === "dark" ? recColorsDark : recColors)[feedback.recommendation] || {})
                    }}>
                        {recLabels[feedback.recommendation] || feedback.recommendation}
                    </span>
                </div>
            )}

            {/* Written feedback */}
            {feedback.summary && (
                <div style={{ marginBottom: 12 }}>
                    <p style={{ fontSize: 12, color: "var(--ink-400)", margin: "0 0 4px" }}>Summary</p>
                    <p style={{ fontSize: 13, margin: 0, lineHeight: 1.5 }}>{feedback.summary}</p>
                </div>
            )}
            {feedback.strengths && (
                <div style={{ marginBottom: 12 }}>
                    <p style={{ fontSize: 12, color: "var(--ink-400)", margin: "0 0 4px" }}>Strengths</p>
                    <p style={{ fontSize: 13, margin: 0, lineHeight: 1.5 }}>{feedback.strengths}</p>
                </div>
            )}
            {feedback.weaknesses && (
                <div style={{ marginBottom: 12 }}>
                    <p style={{ fontSize: 12, color: "var(--ink-400)", margin: "0 0 4px" }}>Weaknesses</p>
                    <p style={{ fontSize: 13, margin: 0, lineHeight: 1.5 }}>{feedback.weaknesses}</p>
                </div>
            )}
            {feedback.suggestions && (
                <div style={{ marginBottom: 12 }}>
                    <p style={{ fontSize: 12, color: "var(--ink-400)", margin: "0 0 4px" }}>Suggestions</p>
                    <p style={{ fontSize: 13, margin: 0, lineHeight: 1.5 }}>{feedback.suggestions}</p>
                </div>
            )}

            {feedback.submittedDate && (
                <p style={{ fontSize: 11, color: "var(--ink-300)", marginTop: 12 }}>
                    Reviewed {new Date(feedback.submittedDate).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}
                </p>
            )}
        </div>
    );
}
